import { render, staticRenderFns } from "./modal_show_related_institution.vue?vue&type=template&id=dd190e8a&scoped=true"
import script from "./modal_show_related_institution.vue?vue&type=script&lang=js"
export * from "./modal_show_related_institution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd190e8a",
  null
  
)

export default component.exports